import { memo } from 'react';

import { SharedFooterProps } from '../../types/SharedFooterProps';
import { Actions } from '../Actions/Actions';
import { Layout } from '../Layout/Layout';
import './Footer.css';

interface Props extends SharedFooterProps {
  size?: 's' | 'm';
}

export const Footer = memo(({ actions, leftActions, size = 'm' }: Props) => {
  const justify = leftActions ? 'between' : 'end';
  return (
    <Layout className="eds-footer" justify={justify}>
      {leftActions && <Actions actions={leftActions} size={size} />}
      <Actions actions={actions} size={size} />
    </Layout>
  );
});

Footer.displayName = 'Footer';
